(() => {
    "use strict"

    const button = document.getElementById('hero-video-playstate-button')

    if (document.getElementById('reviews')) {
        new Splide('#reviews', {
            type: 'loop',
            pagination: false,
            autoplay: true,
            autoplaySpeed: 3000,
        }).mount()
    }

    if (button) {
        const playIcon = button.querySelector('[data-play]')
        const pauseIcon = button.querySelector('[data-pause]')
        const video = document.getElementById(button.dataset.video)

        if (playIcon && pauseIcon && video) {
            const updateIcons = () => {
                const isPlaying = !video.paused && !video.ended
                playIcon.style.display = isPlaying ? 'none' : 'inline-flex'
                pauseIcon.style.display = isPlaying ? 'inline-flex' : 'none'
            }

            video.addEventListener('play', updateIcons)
            video.addEventListener('pause', updateIcons)
            video.addEventListener('ended', updateIcons)

            button.addEventListener('click', () => {
                if (video.paused || video.ended) {
                    video.play()
                }
                else {
                    video.pause()
                }
            })

            updateIcons()
        }
    }
})()